class CarouselBrands extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initializeBlazeSlider();
    }

    initializeBlazeSlider() {
        const blazeSlider = this.querySelector('.carousel-brands__slider');

        const slidesToShowDesktop = this.classList.contains('small-cards') ? 9 : 7;

        if (!blazeSlider) return;

        const slider = new BlazeSlider(blazeSlider, {
            all: {
                transitionDuration: 300,
                transitionTimingFunction: 'cubic-bezier(0.45, 0.1, 0.45, 0.5)',
                slidesToShow: 2.83,
                slidesToScroll: 1,
                slideGap: 'clamp(1.6rem, 1.66667vw, 3.2rem)',
                loop: false,
            },
            '(min-width: 768px)': {
                slidesToShow: slidesToShowDesktop - 3.5,
            },
            '(min-width: 1024px)': {
                slidesToShow: slidesToShowDesktop - 1.5,
            },
            '(min-width: 1440px)': {
                slidesToShow: slidesToShowDesktop,
            }
        });

        const prevBtn = this.querySelector('.carousel-brands__prev');
        const nextBtn = this.querySelector('.carousel-brands__next');

        // Set initial disabled state
        this.updateButtonStates(0, slider);

        if (prevBtn) {
            prevBtn.addEventListener('click', () => slider.prev());
        }
        
        if (nextBtn) {
            nextBtn.addEventListener('click', () => slider.next());
        }

        // Listen for slide changes to update button states
        slider.onSlide((slide, firstVisibleSlide) => {
            this.updateButtonStates(slide, slider);
        });

        
    }

    updateButtonStates(currentSlide, slider) {
        const prevBtn = this.querySelector('.carousel-brands__prev');
        const nextBtn = this.querySelector('.carousel-brands__next');
        
        if (prevBtn && nextBtn) {
            // Disable prev button on first slide
            if (currentSlide === 0) {
                prevBtn.setAttribute('disabled', 'true');
            } else {
                prevBtn.removeAttribute('disabled');
            }
            
            // Disable next button on last slide
            if (currentSlide >= slider.states.length - 1) {
                nextBtn.setAttribute('disabled', 'true');
            } else {
                nextBtn.removeAttribute('disabled');
            }
        }
    }
}

customElements.define('carousel-brands', CarouselBrands);